//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmp from '../../../mixins/virtualCmp'
import { position, show, height } from '../../../mixins/mixinProps'
export default {
  name: 'vc-circle-roatating-double',
  mixins: [cmp, position, show, height],
  props: {
    radius1: {
      type: Number,
      default: 1500
    },
    radius2: {
      type: Number,
      default: 3000
    },
    material1: [Object, String, Array],
    material2: [Object, String, Array],
    deviationRotation1: {
      type: Number,
      default: -0.03
    },
    deviationRotation2: {
      type: Number,
      default: 0.05
    }
  },
  data () {
    return {
      rotation1: 0,
      stRotation1: 0,
      rotation2: 0,
      stRotation2: 0
    }
  },
  methods: {
    async createCesiumObject () {
      this.init()
      return Promise.all([this.$refs.entity1, this.$refs.entity2])
    },
    init () {
      const { deviationRotation1, deviationRotation2 } = this

      let startrotation1 = Cesium.Math.toRadians(30)
      const getRotationValue1 = () => {
        startrotation1 += deviationRotation1
        return startrotation1
      }
      this.rotation1 = getRotationValue1
      this.stRotation1 = getRotationValue1

      let startrotation2 = Cesium.Math.toRadians(30)

      const getRotationValue2 = () => {
        startrotation2 += deviationRotation2
        return startrotation2
      }
      this.rotation2 = getRotationValue2
      this.stRotation2 = getRotationValue2
    },
    async mount () {
      return true
    },
    async unmount () {
      this.rotation1 = undefined
      this.rotation2 = undefined
      this.stRotation1 = undefined
      this.stRotation2 = undefined
      return true
    }
  },
  created () {
    Object.defineProperties(this, {
      entities: {
        enumerable: true,
        get: () => this.cesiumObject
      }
    })
  }
}
